import { useEffect } from 'react';
import { CATALOGO } from '@/constants/catalogo';
import { fmt } from '@/lib/utils';

export default function CfgContenido({ producto, onUpdate }) {
  const catalogo = CATALOGO.contenido;
  const cfg = producto.config || { variante: 'bim-mediodia', ciclos: 6 };

  const recalc = (newCfg) => {
    const v = catalogo.variantes.find((va) => va.id === newCfg.variante);
    if (!v) return;
    const precio = v.precio * (newCfg.ciclos || 1);
    onUpdate({ config: newCfg, precioFinal: precio });
  };

  useEffect(() => {
    if (!producto.configurado) recalc(cfg);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const v = catalogo.variantes.find((va) => va.id === cfg.variante);
  const periodoLabel = v?.periodo === 'mensual' ? 'meses' : 'bimestres';

  return (
    <div className="space-y-3">
      <div className="grid grid-cols-3 gap-2">
        {catalogo.variantes.map((va) => (
          <button
            key={va.id}
            onClick={() => recalc({ ...cfg, variante: va.id })}
            className={`p-3 rounded-lg border text-left ${
              cfg.variante === va.id
                ? 'border-brand-gold bg-brand-gold/10'
                : 'border-neutral-800 bg-neutral-900/50'
            }`}
          >
            <div className="text-white text-xs mb-1">{va.label}</div>
            <div className="text-brand-gold text-xs font-medium">
              {fmt(va.precio)} / {va.periodo}
            </div>
          </button>
        ))}
      </div>
      <div className="flex items-center gap-3">
        <label className="text-xs text-neutral-400 uppercase tracking-wider">
          Cantidad de {periodoLabel}
        </label>
        <input
          type="number"
          min="1"
          value={cfg.ciclos}
          onChange={(e) => recalc({ ...cfg, ciclos: parseInt(e.target.value, 10) || 1 })}
          className="w-24 px-3 py-2 bg-neutral-900 border border-neutral-800 rounded text-white text-sm focus:outline-none focus:border-brand-gold/50"
        />
      </div>
    </div>
  );
}
